export default "__VITE_ASSET__DGlP6ngS__"